import { Box } from '@mui/material';
import { StyledContentContainer } from '../../style';
import PatientMemo from './PatientMemo';
import NursingRecords from './NursingRecords';

interface Props {
  coachRefA: any;
  coachRefB: any;
  menuDrawerWidth: number;
  setMenuDrawerWidth: (menuDrawerWidth: number) => void;
}

const InputInformation = ({
  coachRefA,
  coachRefB,
  menuDrawerWidth,
  setMenuDrawerWidth,
}: Props) => {
  return (
    <Box
      component="aside"
      sx={{
        flex: '0 0 auto',
        width: { xs: 340, xl: 530 },
        minWidth: { xs: 340, xl: 530 },
      }}
    >
      <StyledContentContainer>
        <PatientMemo coachRef={coachRefA} />
        <NursingRecords
          coachRef={coachRefB}
          menuDrawerWidth={menuDrawerWidth}
          setMenuDrawerWidth={setMenuDrawerWidth}
        />
      </StyledContentContainer>
    </Box>
  );
};

export default InputInformation;
